export * from './costCenter.service';
import { CostCenterService } from './costCenter.service';
export * from './costCenter.serviceInterface';
export const APIS = [CostCenterService];
